import { Control, FieldValues, Path, useController } from 'react-hook-form'
import CustomerAutoComplete from 'ui/CustomerAutoComplete/CustomerAutoComplete'
import { Customer } from 'types'
import FieldLayout from './FieldLayout'

interface CustomerFieldProps<T extends FieldValues> {
  name: Path<T>
  control: Control<T>
  label?: string
  placeholder?: string
  disabled?: boolean
  required?: boolean
  onChange?: (customer: Customer | null) => void
}

export const CustomerField = <T extends FieldValues>({
  name,
  control,
  label,
  placeholder,
  required,
  onChange,
}: CustomerFieldProps<T>) => {
  const { field, fieldState } = useController({ name, control })

  return (
    <FieldLayout
      label={label}
      required={required}
      error={fieldState.error?.message}
    >
      <CustomerAutoComplete
        value={field.value}
        onChange={onChange ?? field.onChange}
        placeholder={placeholder}
      />
    </FieldLayout>
  )
}
